export default (endpoint) => {
    var config = {
        "userLogin": {
            "endpoint": "login",
            "modulo": "user",
            "versao": "v1.00"
        },
        "userLogout": {
            "endpoint": "logout",
            "modulo": "user",
            "versao": "v1.00"
        },
        "userProfile": {
            "endpoint": "profile",
            "modulo": "user",
            "versao": "v1.00"
        },
        "userResume": {
            "endpoint": "profile/resume",
            "modulo": "user",
            "versao": "v1.04"
        },
        "userAddress": {
            "endpoint": "profile/address",
            "modulo": "user",
            "versao": "v1.00"
        },
        "userAddressDetails": {
            "endpoint": "profile/address/details",
            "modulo": "user",
            "versao": "v1.02"
        },
        "deliveryTimes": {
            "endpoint": "deliveryTimes",
            "modulo": "user",
            "versao": "v1.02"
        },
        "paymentMethod": {
            "endpoint": "paymentMethod",
            "modulo": "group",
            "versao": "v1.01"
        },
        "paymentMethodImage": {
            "endpoint": "image/payment",
            "modulo": "services",
            "versao": "v1.00"
        },
        "logoImage": {
            "endpoint": "image/logo",
            "modulo": "group",
            "versao": "v1.00"
        },
        "bannerImage": {
            "endpoint": "image",
            "modulo": "services",
            "versao": "v1.00"
        },
        "changePassword": {
            "endpoint": "changePassword",
            "modulo": "user",
            "versao": "v1.00"
        },
        "passwordRecovery": {
            "endpoint": "passwordRecovery",
            "modulo": "user",
            "versao": "v1.00"
        },
        "userTabs": {
            "endpoint": "tabs",
            "modulo": "user",
            "versao": "v1.02"
        },
        "userSubcat": {
            "endpoint": "subcat",
            "modulo": "user",
            "versao": "v1.00"
        },
        "productDetails": {
            "endpoint": "productdetails",
            "modulo": "user",
            "versao": "v1.03"
        },
        "favorites": {
            "endpoint": "favorites",
            "modulo": "user",
            "versao": "v1.00"
        },
        "feed": {
            "endpoint": "feed",
            "modulo": "user",
            "versao": "v1.03"
        },
        "offers": {
            "endpoint": "offers",
            "modulo": "user",
            "versao": "v1.04"
        },
        "cluster": {
            "endpoint": "cluster",
            "modulo": "user",
            "versao": "v1.04"
        },
        "campaign": {
            "endpoint": "campaign",
            "modulo": "user",
            "versao": "v1.04"
        },
        "voucher": {
            "endpoint": "vouchers",
            "modulo": "user",
            "versao": "v1.00"
        },
        "vouchers": {
            "endpoint": "vouchers",
            "modulo": "user",
            "versao": "v1.01"
        },
        "connectActivate": {
            "endpoint": "connect/activate",
            "modulo": "user",
            "versao": "v1.00"
        },
        "offerFamily": {
            "endpoint": "offer/family",
            "modulo": "user",
            "versao": "v1.00"
        },
        "crmpointsProduct": {
            "endpoint": "crmpoints/vr/product",
            "modulo": "user",
            "versao": "v1.00"
        },
        "crmpointsResume": {
            "endpoint": "crmpoints/vr/resume",
            "modulo": "user",
            "versao": "v1.00"
        },
        "crmpointsHistory": {
            "endpoint": "crmpoints/vr/history",
            "modulo": "user",
            "versao": "v1.00"
        },
        "crmpointsHistoryExpire": {
            "endpoint": "crmpoints/vr/history/expire",
            "modulo": "user",
            "versao": "v1.00"
        },
        "userFlyers": {
            "endpoint": "flyer",
            "modulo": "user",
            "versao": "v1.00"
        },
        "userReminder": {
            "endpoint": "reminder",
            "modulo": "user",
            "versao": "v1.01"
        },
        "userReminderBy": {
            "endpoint": "reminder",
            "modulo": "user",
            "versao": "v1.00"
        },
        "savedValue": {
            "endpoint": "savedValue",
            "modulo": "user",
            "versao": "v1.00"
        },
        "shake": {
            "endpoint": "shake",
            "modulo": "user",
            "versao": "v1.00"
        },
        "storeCity": {
            "endpoint": "store",
            "modulo": "group",
            "versao": "v1.01"
        },
        "init": {
            "endpoint": "init",
            "modulo": "group",
            "versao": "v1.04"
        },
        "footer": {
            "endpoint": "footer",
            "modulo": "group",
            "versao": "v1.01"
        },
        "policy": {
            "endpoint": "policy",
            "modulo": "group",
            "versao": "v1.00"
        },
        "storePickup": {
            "endpoint": "storePickup",
            "modulo": "group",
            "versao": "v1.01"
        },
        "servicesImage": {
            "endpoint": "image",
            "modulo": "services",
            "versao": "v1.00"
        },
        "servicesPdf": {
            "endpoint": "pdf",
            "modulo": "services",
            "versao": "v1.00"
        },
        "currentOrder": {
            "endpoint": "currentOrder",
            "modulo": "user",
            "versao": "v1.04"
        },
        "clearCart": {
            "endpoint": "currentOrder/clear",
            "modulo": "user",
            "versao": "v1.01"
        },
        "preOrder": {
            "endpoint": "preOrder",
            "modulo": "user",
            "versao": "v1.02"
        },
        "finalizeOrder": {
            "endpoint": "finalizeOrder",
            "modulo": "user",
            "versao": "v1.04"
        },
        "orders": {
            "endpoint": "orders",
            "modulo": "user",
            "versao": "v1.00"
        },
        "order": {
            "endpoint": "order",
            "modulo": "user",
            "versao": "v1.03"
        },
        "profileDelivery": {
            "endpoint": "profile/delivery",
            "modulo": "user",
            "versao": "v1.01"
        },
        "findProduct": {
            "endpoint": "findProduct",
            "modulo": "user",
            "versao": "v1.04"
        },
        "findProductResume": {
            "endpoint": "findProduct/resume",
            "modulo": "user",
            "versao": "v1.04"
        },
        "shareOffer": {
            "endpoint": "share/offer",
            "modulo": "user",
            "versao": "v1.00"
        },
        "viewReminder": {
            "endpoint": "view/reminder",
            "modulo": "user",
            "versao": "v1.00"
        },
        "like": {
            "endpoint": "like",
            "modulo": "user",
            "versao": "v1.00"
        },
        "banners": {
            "endpoint": "banners",
            "modulo": "group",
            "versao": "v1.00"
        },
        "fixedBanners": {
            "endpoint": "fixedBanners",
            "modulo": "group",
            "versao": "v1.00"
        },
        "addressZipCode": {
            "endpoint": "address/zipCode",
            "modulo": "services",
            "versao": "v1.00"
        },
        "geoLocationByAddress": {
            "endpoint": "address/geoLocationByAddress",
            "modulo": "services",
            "versao": "v1.00"
        },
        "addressByGeoLocation": {
            "endpoint": "address/addressByGeoLocation",
            "modulo": "services",
            "versao": "v1.00"
        },
        "npsEcommerce": {
            "endpoint": "nps/ecommerce",
            "modulo": "user",
            "versao": "v1.00"
        },
        "npsPhysical": {
            "endpoint": "nps/phisycal",
            "modulo": "user",
            "versao": "v1.00"
        },
        "npsStore": {
            "endpoint": "nps/store",
            "modulo": "user",
            "versao": "v1.00"
        },
        "account": {
            "endpoint": "account",
            "modulo": "user",
            "versao": "v1.00"
        },
        "live": {
            "endpoint": "live",
            "modulo": "user",
            "versao": "v1.00"
        },
        "verifyDocument": {
            "endpoint": "verifyDocument",
            "modulo": "user",
            "versao": "v1.00"
        },
        "orderRepeat": {
            "endpoint": "order/repeat",
            "modulo": "user",
            "versao": "v1.01"
        },
        "cancelOrder": {
            "endpoint": "order/cancel",
            "modulo": "user",
            "versao": "v1.00"
        },
        "wallet": {
            "endpoint": "wallet",
            "modulo": "user",
            "versao": "v1.00"
        },
        "walletBalance": {
            "endpoint": "wallet/balance",
            "modulo": "user",
            "versao": "v1.00"
        },
        "cupom": {
            "endpoint": "coupon",
            "modulo": "user",
            "versao": "v1.00"
        },
        "cupons": {
            "endpoint": "coupons",
            "modulo": "user",
            "versao": "v1.00"
        },
        "fullproduct": {
            "endpoint": "fullproduct",
            "modulo": "user",
            "versao": "v1.00"
        },
        "infonutri": {
            "endpoint": "infonutri",
            "modulo": "user",
            "versao": "v1.00"
        },
        "related": {
            "endpoint": "related",
            "modulo": "user",
            "versao": "v1.01"
        },
        "userContainers": {
            "endpoint": "containers",
            "modulo": "user",
            "versao": "v1.00"
        },        
        "onlinePaymentFlags": {
            "endpoint": "onlinePaymentFlags",
            "modulo": "user",
            "versao": "v1.00"
        },
        "visits": {
            "endpoint": "visits",
            "modulo": "user",
            "versao": "v1.00"
        },
        "paymentOnlineImage": {
            "endpoint": "image/onlinepayment",
            "modulo": "services",
            "versao": "v1.00"
        },
        "extraImages": {
            "endpoint": "product/extraImages",
            "modulo": "user",
            "versao": "v1.00"
        },
        "pix": {
            "endpoint": "pix/brcode",
            "modulo": "user",
            "versao": "v1.00"
        },
    };
    return config[endpoint];
}